import { render, staticRenderFns } from "./ShowPhotos.vue?vue&type=template&id=3c90598a&scoped=true"
import script from "./ShowPhotos.vue?vue&type=script&lang=js"
export * from "./ShowPhotos.vue?vue&type=script&lang=js"
import style0 from "./ShowPhotos.vue?vue&type=style&index=0&id=3c90598a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c90598a",
  null
  
)

export default component.exports